<!-- Search -->
<div class="row search-container">
  <div id="Organization-tab" class="search-container-tab col s12">
    <i class="material-icons search-icon" [attr.aria-label]="'UNIVERSAL-SEARCH' | translate">search</i>
    <ng-select 
      class="completer" 
      name="searchSelect" 
      [items]="ngSelectData" 
      [typeahead]="searchInput$" 
      [minTermLength]="3"
      [loading]="isLoading" 
      bindLabel="title" 
      [clearable]="false"
      notFoundText="{{ 'SearchComponent-SEARCH_NOT_FOUND' | translate }}"
      loadingText="{{ 'UNIVERSAL-SEARCHING' | translate }}"
      placeholder="{{ 'SearchComponent-SEARCH_PLACEHOLDER' | translate }}" 
      (search)="onSearchInput($event)"
      (change)="onNgSelectItem($event)" 
      (close)="onDropdownClose()" 
      [(ngModel)]="ngSelectSearchStr">
      <ng-template ng-option-tmp let-item="item">
        <div class="completer-item">
          <img class="completer-image" [src]="item.image" width="24" height="24">
          <div class="completer-text">
            <span class="completer-title">{{ item.title }}</span>
            <span class="completer-description">{{ item.description }}</span>
          </div>
        </div>
      </ng-template>
    </ng-select> 
    <i class="material-icons clear-icon" [attr.aria-label]="'UNIVERSAL-NAVIGATION_CANCEL' | translate"
      *ngIf="currentSearchTerm" (click)="onClear()">close</i>
    <!-- <div class="advanced-search col s12">
      <a
        disabled
        class="disabled">
        {{ 'SearchComponent-ADVANCED_ORGANIZATION_TITLE' | translate }}
      </a>
    </div> -->
  </div>
</div>
<div class="row">
  <div class="col s12">
    {{ 'SearchComponent-LABEL-NARROW-BY' | translate }}
  </div>
  <div class="col l3 s6">
    <input id="all-chk" type="checkbox" (click)="toggleAll($event)" [(ngModel)]="allChecked" />
    <label for="all-chk">{{ 'SearchComponent-LABEL-ALL' | translate }}</label>
  </div>
  <div class="col l3 s6">
    <input id="disaster-chk" type="checkbox" (change)="toggleEnum($event.target.checked, searchEnum.Disaster)"
      [(ngModel)]="disasterChecked" />
    <label for="disaster-chk">{{ 'SearchComponent-LABEL-DISASTERS' | translate }} </label>
  </div>
  <div class="col l3 s6">
    <input id="location-chk" type="checkbox" (change)="toggleEnum($event.target.checked, searchEnum.Location)"
      [(ngModel)]="locationChecked" />
    <label for="location-chk">{{ 'SearchComponent-LABEL-LOCATIONS' | translate }} </label>
  </div>
  <div class="col l3 s6">
    <input id="organization-chk" type="checkbox"
      (change)="toggleEnum($event.target.checked, searchEnum.Organization)" 
      [(ngModel)]="organizationChecked" />
    <label for="organization-chk">{{ 'SearchComponent-LABEL-ORGANIZATIONS' | translate }} </label>
  </div>
</div>